'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

require('./styles/index.scss.js');
require('../node_modules/react-responsive-modal/styles.css.js');
var Button = require('./components/Button/Button.js');
var ButtonGroup = require('./components/ButtonGroup/ButtonGroup.js');
var Badge = require('./components/Badge/Badge.js');
var Checkbox = require('./components/Checkbox/Checkbox.js');
var Icon = require('./components/Icon/Icon.js');
var Switch = require('./components/Switch/Switch.js');
var Radio = require('./components/Radio/Radio.js');
var RadioGroup = require('./components/RadioGroup/RadioGroup.js');
var Avatar = require('./components/Avatar/Avatar.js');
var Input = require('./components/Input/Input.js');
var Loader = require('./components/Loader/Loader.js');
var Footer = require('./components/Footer/Footer.js');
var Navbar = require('./components/Navbar/Navbar.js');
var index$4 = require('./components/Navbar/MobileNavigation/index.js');
var Carousel = require('./components/Carousel/Carousel.js');
var Pagination = require('./components/Pagination/Pagination.js');
var Modal = require('./components/Modal/Modal.js');
var DropDown = require('./components/DropDown/DropDown.js');
var Accordion = require('./components/Accordion/Accordion.js');
var Stepper = require('./components/Stepper/Stepper.js');
var Tabs = require('./components/Tabs/Tabs.js');
var BottomNavigation = require('./components/BottomNavigation/BottomNavigation.js');
var ViewMore = require('./components/ViewMore/ViewMore.js');
var Login = require('./components/Login/Login.js');
var index = require('./components/MFELogin/index.js');
var index$1 = require('./components/Swiper/index.js');
var Alert = require('./components/Alert/Alert.js');
var LifepalLoader = require('./components/Loader/LifepalLoader.js');
var SEOAccordion = require('./components/SEOAccordion/SEOAccordion.js');
var index$3 = require('./components/Skeleton/index.js');
var LifepalProvider = require('./components/LifepalProvider/LifepalProvider.js');
var index$2 = require('./components/RouteGuard/index.js');
var ResponsiveModal = require('./components/ResponsiveModal/ResponsiveModal.js');
var FunctionModal = require('./components/FunctionModal/FunctionModal.js');
var useMediaQueries = require('./utils/hooks/useMediaQueries.js');
var handlePhoneNumber = require('./utils/handlePhoneNumber.js');



exports.Button = Button.Button;
exports.ButtonGroup = ButtonGroup.ButtonGroup;
exports.Badge = Badge.Badge;
exports.Checkbox = Checkbox.Checkbox;
exports.Icon = Icon.Icon;
exports.Switch = Switch.Switch;
exports.Radio = Radio.Radio;
exports.RadioGroup = RadioGroup.RadioGroup;
exports.Avatar = Avatar.Avatar;
exports.Input = Input.Input;
exports.Loader = Loader.Loader;
exports.Footer = Footer.Footer;
exports.Navbar = Navbar.Navbar;
exports.useNavbarContext = Navbar.useNavbarContext;
exports.MobileNavigation = index$4.MobileNavigation;
exports.Carousel = Carousel.Carousel;
exports.CarouselSlide = Carousel.CarouselSlide;
exports.Pagination = Pagination.Pagination;
exports.Modal = Modal.Modal;
exports.DropDown = DropDown.DropDown;
exports.Accordion = Accordion.Accordion;
exports.Stepper = Stepper.Stepper;
exports.Tabs = Tabs.Tabs;
exports.BottomNavigation = BottomNavigation.BottomNavigation;
exports.ViewMore = ViewMore.ViewMore;
exports.Login = Login.Login;
exports.MFELogin = index;
exports.Swiper = index$1;
exports.Alert = Alert.Alert;
exports.LifepalLoader = LifepalLoader.LifepalLoader;
exports.SEOAccordion = SEOAccordion.SEOAccordion;
exports.Skeleton = index$3.Skeleton;
exports.LifepalProvider = LifepalProvider.LifepalProvider;
exports.getUserToken = LifepalProvider.getUserToken;
exports.removeLoginData = LifepalProvider.removeLoginData;
exports.useLifepalContext = LifepalProvider.useLifepalContext;
exports.RouteGuard = index$2;
exports.ResponsiveModal = ResponsiveModal;
exports.ModalContainer = FunctionModal.ModalContainer;
exports.defaultOptions = FunctionModal.defaultOptions;
exports.show = FunctionModal.show;
exports.useMediaQueries = useMediaQueries.useMediaQueries;
exports.formatPhoneNumber = handlePhoneNumber.formatPhoneNumber;
exports.handlePhoneNumber = handlePhoneNumber.handlePhoneNumber;
exports.idnPhoneNumber = handlePhoneNumber.idnPhoneNumber;
exports.idnPhoneValidation = handlePhoneNumber.idnPhoneValidation;
//# sourceMappingURL=index.js.map
